const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

const format = (cents: number) => formatter.format(cents / 100);

const formatBudgetRange = (minCents?: number, maxCents?: number) => {
  if (minCents !== undefined && maxCents !== undefined) {
    if (minCents === maxCents) {
      return `${format(minCents)}`;
    }
    return `${format(minCents)} - ${format(maxCents)}`;
  }

  if (minCents !== undefined) {
    return format(minCents);
  }
  if (maxCents !== undefined) {
    return format(maxCents);
  }

  return;
};

export default formatBudgetRange;
